module.exports = __webpack_public_path__ + "static/media/gravure5.2e426781.jpg";